import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { GoalDetailsComponent } from './goal-details.component';
import { TranslateModule } from '../../../../shared/translate/translate.module';

@NgModule({
  imports: [CommonModule, IonicModule, TranslateModule],
  declarations: [GoalDetailsComponent],
  exports: [GoalDetailsComponent]
})
export class GoalDetailsModule { }
